import React from 'react';
import { Form as CoreForm } from '@sparefoot/react-core/Form';
import PropTypes from 'prop-types';
import withFormTracking from '../library/tracking-utils/tracking/withFormTracking';

const enhance = withFormTracking;
const Form = (props) => {
	return <CoreForm {...props}>{props.children}</CoreForm>;
};

Form.propTypes = {
	children: PropTypes.node,
};

export default enhance(Form);
